import {
  CONFIRM_DIALOG_OPEN,
  CONFIRM_DIALOG_CLOSE
} from 'types/actions/confirm-dialog'
import Deferred from 'node-deferred'

let deferred = null

export const _openConfirmDialog = (data = {}) => ({
  type: CONFIRM_DIALOG_OPEN,
  open: true,
  data
})

export const _closeConfirmDialog = (data = {}) => ({
  type: CONFIRM_DIALOG_CLOSE,
  open: false,
  data
})

export const openConfirmDialog = (data = {}) => {
  return dispatch => {
    deferred = new Deferred()
    dispatch(_openConfirmDialog(data))
    return deferred.promise
  }
}

export const closeConfirmDialog = isConfirm => {
  return dispatch => {
    if (isConfirm) {
      deferred.resolve()
    } else {
      deferred.reject()
    }
    dispatch(_closeConfirmDialog())
  }
}



// WEBPACK FOOTER //
// ./src/actions/confirm-dialog.js